module.exports = "/images/lock.svg?904a0f09bfbcdff067dfb353f03d64a1";